export function daysSinceEpoch(milliseconds: number) {
  return Math.floor(milliseconds / (1000 * 60 * 60 * 24));
}
